import { render, staticRenderFns } from "./sendTeacEcology.vue?vue&type=template&id=d2027e32&scoped=true&"
import script from "./sendTeacEcology.vue?vue&type=script&lang=js&"
export * from "./sendTeacEcology.vue?vue&type=script&lang=js&"
import style0 from "./sendTeacEcology.vue?vue&type=style&index=0&id=d2027e32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2027e32",
  null
  
)

export default component.exports